import React from 'react';
import { BeatLoader } from 'react-spinners';

const CustomBeatLoader = (props) => {
  const { className, size = 30, isLoading } = props;

  return (
    <div className={className}>
      <BeatLoader size={size} color="#6200ea" margin={12} loading={isLoading} />
    </div>
  );
};

export default CustomBeatLoader;
